<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>CMODULE.TITLE</div>

</ion-header>

<ion-content class="page" no-bounce scroll>
  <div [ngClass]="'warn-en warn-en' + warnEn" translate>CMODULE.WARN_EN</div>
  <div class="buffer"></div>
  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && !hasCModules">
    <ion-label class="no-entries-label" *ngIf="!hasCModules" translate>CMODULE.NO_ENTRIES</ion-label>
  </ng-template>

  <ion-list [ngClass]="hasCModules ? 'cmodule-list show' : 'cmodule-list'">
    <div *ngFor="let cmodule of cmodules; trackBy: trackCModules">
      <ion-item size="12" size-sm="12" (click)="selectCModule(cmodule)" [ngClass]="(cmodule._id + '' == selectedCModuleId) ? 'cmodule-title selected' : 'cmodule-title'">
        <ion-label class="ion-text-wrap cmodule-title">
           {{getLocalizedCModuleText(cmodule.title)}}
        </ion-label>
        <ion-icon aria-hidden="true" name="close-outline" slot="end" class="open-close"></ion-icon>
        <div class="badge-area">
          <ion-badge *ngIf="cmodule.state == 5" class="badge badge5"><ion-icon name="play" class="icon"></ion-icon></ion-badge>
          <ion-badge *ngIf="cmodule.state == 9" class="badge badge9"><ion-icon name="checkmark" class="icon"></ion-icon></ion-badge>
        </div>
      </ion-item>
      <div class="cmodule-body">
        <collapsible [expanded]="(cmodule._id + '' == selectedCModuleId)">
          <ion-grid>
            <ion-row>
              <ion-col size="12" class="cmodule-description">
                <rich-text class="description" [text]="getLocalizedCModuleText(cmodule.description)">
                </rich-text>
              </ion-col>
            </ion-row>
            <ion-row class="action" *ngIf="cmodule.state == 9">
              <ion-col size="6">
                <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(cmodule, $event)">
                  CMODULE.BUTTON.PDF
                </ion-button>
              </ion-col>
              <ion-col size="6">
              </ion-col>
            </ion-row>
          </ion-grid>
          <ng-template ngFor let-content [ngForOf]="cmodule.fullContents" let-i="index" let-last="last" [ngForTrackBy]="trackContents">
              <ion-item size="12" size-sm="12" (click)="contentExpanded[cmodule._id + '_' + i] = !contentExpanded[cmodule._id + '_' + i]" 
                [ngClass]="'item-level-2 content-title' + (last ? ' last' : '')" id="{{cmodule._id + '_' + content._id + '_title'}}" >
                <ion-label class="ion-text-wrap">
                  {{getLocalizedCModuleText(content.title)}}
                </ion-label>
                <ion-icon name="chevron-down-outline" slot="end" [ngClass]="contentExpanded[cmodule._id + '_' + i] !== undefined && contentExpanded[cmodule._id + '_' + i] === true ? 'chevron expanded' : 'chevron'"></ion-icon>
                <div class="badge-area">
                  <ion-badge *ngIf="getUcState(cmodule, i) == 5 || getUcState(cmodule, i) == 6" class="content-progress">{{getProgress(getUc(cmodule, i))}}</ion-badge>
                  <ion-badge *ngIf="!isLeader && showLeaderContent && content.leadersOnly " class="badge badge-leader"><ion-icon name="people" class="icon"></ion-icon></ion-badge>
                  <ion-badge *ngIf="getUcState(cmodule, i) == 5" class="badge badge5"><ion-icon name="play" class="icon"></ion-icon></ion-badge>
                  <ion-badge *ngIf="getUcState(cmodule, i) == 6" class="badge badge6"><ion-icon name="pause" class="icon"></ion-icon></ion-badge>
                  <ion-badge *ngIf="getUcState(cmodule, i) >= 8" class="badge badge9"><ion-icon name="checkmark" class="icon"></ion-icon></ion-badge>
                </div>
              </ion-item>
              <collapsible [expanded]="contentExpanded[cmodule._id + '_' + i] !== undefined && contentExpanded[cmodule._id + '_' + i] === true">
                <ion-item id='{{content._id}}' class="cmodule-body item-level-3" (click)="showContent(getUc(cmodule, i))">
                  <ion-grid>
                    <ion-row>
                      <ion-col size="12">
                        <rich-text class="description" [text]="getLocalizedCModuleText(content.description)">
                        </rich-text>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 0">
                      <ion-col size="6">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: content.weeks}">
                          {{content.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="start(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.START
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 5">
                      <ion-col size="12" *ngIf="!content.pausable">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(getUc(cmodule, i, 'startDate'))}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" *ngIf="content.pausable">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(getUc(cmodule, i, 'startDate'))}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field" *ngIf="content.pausable">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="pause(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.PAUSE
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 6">
                      <ion-col size="6">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(getUc(cmodule, i, 'startDate'))}">
                          CONTENT.INFO.PAUSED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="resume(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.RESUME
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 8">
                      <ion-col size="12">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(getUc(cmodule, i, 'startDate')), endDatum: formateDate(getUc(cmodule, i, 'doneDate'))}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 8">
                      <ion-col size="6">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.PDF
                        </ion-button>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 9">
                      <ion-col size="12">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(getUc(cmodule, i, 'startDate')), endDatum: formateDate(getUc(cmodule, i, 'doneDate'))}">
                          CONTENT.INFO.DONE
                        </ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="getUcState(cmodule, i) == 9">
                      <ion-col size="6">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.PDF
                        </ion-button>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="restart(getUc(cmodule, i), $event)">
                          CONTENT.BUTTON.RESTART
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>
              </collapsible>
            </ng-template>
            </collapsible>
          </div>
        </div>
      </ion-list>
  <instruction key="cmodules">{{'INSTRUCTION.CMODULES' | translate}}</instruction>

</ion-content>
